import {
  Flexbox,
  FormField,
  Grid,
  Text,
  TextInput,
} from "@sede-enterprise/shell-ds-react-framework";
import type { IDealDetails } from "../../../../types/types";
import { getInputFields } from "../DealDetailFunctions";

// Helper function to normalize EVP name for comparison
const normalizeEvpName = (evpName: string): string => {
  return evpName.toLowerCase().replace(/[^a-z0-9]/g, "");
};

const InputForm = (props: { selectConfig: IDealDetails[] }) => {
  const { selectConfig } = props;
  const inputFields = getInputFields(selectConfig);

  // Determine EVP type for conditional layouts
  const isTSProducts = normalizeEvpName(inputFields.evpName) === "tsproducts";
  const isSLMT = normalizeEvpName(inputFields.evpName) === "slmt";

  return (
    <div className="non-edit-form">
      <Grid columns={1} style={{ marginTop: "10px" }}>
        <FormField id="opportunityName" label="Opportunity Name">
          <TextInput disabled value={inputFields?.opportunityName} />
        </FormField>
      </Grid>
      {isTSProducts ? (
        <>
          <Grid style={{ gridTemplateColumns: "1fr 2fr 1fr" }}>
            <FormField id="evpName" label="EVP">
              <TextInput disabled value={inputFields.evpName} />
            </FormField>
            <FormField id="business" label="Business">
              <TextInput disabled value={inputFields.businessName} />
            </FormField>
            <FormField id="region" label="Region">
              <TextInput disabled value={inputFields.region} />
            </FormField>
          </Grid>
          <Grid columns={3}>
            <FormField id="country" label="Country">
              <TextInput disabled value={inputFields.country} />
            </FormField>
            <FormField id="commodity" label="Product">
              <TextInput disabled value={inputFields.commodity} />
            </FormField>
            <FormField id="carbonCredit" label="Carbon Credit">
              <TextInput disabled value={inputFields.carbonCredit} />
            </FormField>
          </Grid>
        </>
      ) : isSLMT ? (
        <>
          <Grid columns={3}>
            <FormField id="evpName" label="EVP">
              <TextInput disabled value={inputFields.evpName} />
            </FormField>
            <FormField id="business" label="Business">
              <TextInput disabled value={inputFields.businessName} />
            </FormField>
            <FormField id="typeOfSupply" label="Type of Supply">
              <TextInput disabled value={inputFields.typeOfSupply} />
            </FormField>
          </Grid>
          <Grid columns={2}>
            <FormField id="country" label="Country/Asset of Supply">
              <TextInput disabled value={inputFields.country} />
            </FormField>
            <FormField id="commodity" label="Commodity">
              <TextInput disabled value={inputFields.commodity} />
            </FormField>
          </Grid>
        </>
      ) : (
        <>
          <Grid columns={4}>
            <FormField id="evpName" label="EVP">
              <TextInput disabled value={inputFields.evpName} />
            </FormField>
            <FormField id="business" label="Business">
              <TextInput disabled value={inputFields.businessName} />
            </FormField>
            <FormField id="region" label="Region">
              <TextInput disabled value={inputFields.region} />
            </FormField>
            <FormField id="country" label="Country">
              <TextInput disabled value={inputFields.country} />
            </FormField>
          </Grid>
          <Grid columns={3}>
            <FormField id="commodity" label="Commodity">
              <TextInput disabled value={inputFields.commodity} />
            </FormField>
            <FormField id="techSource" label="Technology Source">
              <TextInput
                disabled
                value={
                  Array.isArray(inputFields.techSource)
                    ? inputFields.techSource.join(", ")
                    : inputFields.techSource
                }
              />
            </FormField>
            <FormField id="gridLocation" label="Grid Location">
              <TextInput disabled value={inputFields.gridLocation} />
            </FormField>
          </Grid>
        </>
      )}
      {inputFields.showGasFields ? (
        <Grid columns={4}>
          <FormField id="assetType" label="Asset Type">
            <TextInput disabled value={inputFields.assetType} />
          </FormField>
          <FormField id="fuelType" label="Fuel Type">
            <TextInput disabled value={inputFields.fuelType} />
          </FormField>
          <FormField id="operatingModel" label="Operating Model">
            <TextInput disabled value={inputFields.operatingModel} />
          </FormField>
          <Flexbox columnGap="12px">
            <FormField id="equityPercentage" label="Equity Share (%)">
              <TextInput disabled value={inputFields.equityShare} />
            </FormField>
            <FormField id="efficiencyPercentage" label="Efficiency (LHV%)">
              <TextInput disabled value={inputFields.efficiency} />
            </FormField>
          </Flexbox>
        </Grid>
      ) : null}
      <Grid columns={isSLMT ? 3 : 4}>
        <FormField id="unitOfMeasure" label="Unit Of Measure">
          <TextInput disabled value={inputFields.unitOfMeasure} />
        </FormField>
        {!isSLMT && (
          <FormField
            id="grossMargin"
            label={isTSProducts ? "Gross Margin (Thousand USD)" : "Gross Margin (Million USD)"}
          >
            <TextInput disabled value={inputFields.grossMargin} />
          </FormField>
        )}
        <FormField id="startDate" label="Start Date">
          <TextInput disabled value={inputFields.startDate} />
        </FormField>
        <FormField id="endDate" label="End Date">
          <TextInput disabled value={inputFields.endDate} />
        </FormField>
      </Grid>
      {!isTSProducts && (
        <Text size="small" style={{ color: "#000000", marginTop: "5px" }}>
          <em>
            Base case gross margin i.e. Revenue less purchases less direct variable trading costs
            (e.g. storage, transportation, transmission) to be presented in USD, MOD. <br />
            Deals denominated in other currencies will require translation using group FX rates.
          </em>
        </Text>
      )}
    </div>
  );
};

export default InputForm;
